// extracted by mini-css-extract-plugin
export default {"price":"d7-z","priceRow":"e7-z","onSale":"f7-z","msrpLabelPrice":"g7-z","msrpLabel":"h7-z","originalPrice":"i7-z","percentOff":"j7-z"};